import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useAppSelector } from './hooks'
import { split, first } from 'lodash'
import  secureLocalStorage  from  "react-secure-storage";
import { TOKEN_STORAGE, APP_ID_STORAGE } from '../constants';
import { v4 as uuidv4 } from 'uuid';

interface TokenState {
	bondedPairToken: string|undefined,
	appID: string|undefined,
}

const initialState: TokenState ={
	bondedPairToken: undefined,
	appID: undefined,
}

export const tokenSlice = createSlice({
  name: 'token',
  initialState: initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
				// Redux Toolkit allows us to write "mutating" logic in reducers. It
				// doesn't actually mutate the state because it uses the Immer library,
				// which detects changes to a "draft state" and produces a brand new
				// immutable state based off those changes
				state.bondedPairToken = action.payload
				const accessToken = `Bearer ${first(split(action.payload, ','))}`
				secureLocalStorage.setItem(TOKEN_STORAGE, accessToken)
    },
    clearToken: (state) => {
      	state.bondedPairToken = undefined
				secureLocalStorage.removeItem(TOKEN_STORAGE)
    },
    
		setAppId: (state, action: PayloadAction<string>) => {		
			secureLocalStorage.setItem(APP_ID_STORAGE, action.payload)
    },
  }
})

// Action creators are generated for each case reducer function
export const { setToken, clearToken, setAppId } = tokenSlice.actions

export default tokenSlice.reducer

//Helper functions
export function getAccessToken() {
	return secureLocalStorage.getItem(TOKEN_STORAGE);
}

export function getAppId() : string {
	return secureLocalStorage.getItem(APP_ID_STORAGE) as string
}

export function generateAppId() : string {
	const appId = getAppId();

	if (appId === null) {
		return uuidv4();
	}

	return appId
}

export function IsLoggedIn() {
	return  useAppSelector(state =>  state.token.bondedPairToken) !== undefined
}